import { Swiper } from "swiper";
import { Autoplay } from "swiper/modules";

Swiper.use( Autoplay );

( () => {
    new Swiper('.tagline-slider', {
        speed: 5000,
        loop: true,
        slidesPerView: 'auto',
        freeMode: true,
        allowTouchMove: false,
        centeredSlides: true,
        autoplay: {
            delay: 0,
            disableOnInteraction: false
        }
    } );
} )();